import 'globals';

(function ($, window, document, PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function() {
        $('.circleCounter').each(function () {
            var duration = $(this).data('duration'),
                value = $(this).data('value'),
                suffix = $(this).data('suffix'),
                dummy = document.createElement('div'),
                counter = this;

            $(dummy).prop('circleCounter', 0).animate({
                'circleCounter': value,
            }, {
                'duration': value / 100 * duration,
                'step': function (now) {
                    $('.circleCounter__value', counter).text(Math.ceil(now) + (typeof suffix != 'undefined' ? suffix : ''));

                    var deg = now / 100 * 360;

                    $('.circleCounter__corner--tr .circleCounter__cornerFill', counter).css('transform', 'rotate(' + Math.max(Math.min((0) + deg - 90, 0), -90) + 'deg)');
                    $('.circleCounter__corner--br .circleCounter__cornerFill', counter).css('transform', 'rotate(' + Math.max(Math.min((-90) + deg - 90, 0), -90) + 'deg)');
                    $('.circleCounter__corner--bl .circleCounter__cornerFill', counter).css('transform', 'rotate(' + Math.max(Math.min((-180) + deg - 90, 0), -90) + 'deg)');
                    $('.circleCounter__corner--tl .circleCounter__cornerFill', counter).css('transform', 'rotate(' + Math.max(Math.min((-270) + deg - 90, 0), -90) + 'deg)');
                }
            });
        });
    });
})(jQuery, window, document, window.PageLoadedQueue);
